export const getStepFromQuery = () => {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get('step');
};

export const updateStepQuery = step => {
  var searchParams = new URLSearchParams(window.location.search);
  searchParams.set('step', step);
  var newRelativePathQuery =
    window.location.pathname + '?' + searchParams.toString();
  window.history.replaceState(null, '', newRelativePathQuery);
};
